export const statistiquesTranslations = {
  fr: {
    title: "Mes Statistiques",
    subtitle: "Votre utilisation de l'IA ce mois-ci",
    loadingChart: "Chargement du graphique",
    export: "Exporter",
    refresh: "Actualiser",
    loadError: "Erreur lors du chargement des statistiques",
    refreshed: "Statistiques actualisées",
    refreshError: "Erreur lors de l'actualisation",
    exported: "Données exportées",
    noExportData: "Aucune donnée à exporter",
    exportError: "Erreur lors de l'export",
    loginRequired: "Connexion requise",
    loginRequiredDesc: "Connectez-vous pour voir vos statistiques d'utilisation",
    loadingStats: "Chargement de vos statistiques...",
    monthlyUsage: "Utilisation Mensuelle",
    consumptionFor: "Votre consommation pour {{month}}",
    costUsed: "Coût utilisé",
    nearLimit: "⚠️ Vous approchez de votre limite mensuelle",
    requests: "Requêtes",
    tokens: "Tokens",
    plan: "Plan",
    dailyEvolution: "Évolution quotidienne",
    byFunction: "Par fonction",
    dailyEvolutionTitle: "Évolution Quotidienne",
    usageByFunction: "Utilisation par Fonction",
    noUsageThisMonth: "Aucune utilisation ce mois-ci",
    noFunctionUsed: "Aucune fonction utilisée ce mois-ci",
    requestsCount: "requêtes",
    cost: "Coût",
    tierLabels: {
      free: "Gratuit",
      basic: "Basique",
      premium: "Premium",
      premium_free: "Premium Gratuit",
      essential: "Essentiel",
      pro: "Pro",
    },
    funcLabels: {
      "chat-ai": "Chat IA",
      "code-suggest": "Codage PMSI",
      "generate-daily-quiz": "Quiz du jour",
      "generate-study-content": "Génération QCM",
      "generate-flashcards-from-conversation": "Flashcards depuis conversation",
      "analyze-medication": "Analyse médicament",
      "generate-study-from-conversation": "Étude depuis conversation",
      "process-rss-feeds": "Veille RSS",
      "generate-clinical-case": "Cas clinique",
    },
  },
  en: {
    title: "My Statistics",
    subtitle: "Your AI usage this month",
    loadingChart: "Loading chart",
    export: "Export",
    refresh: "Refresh",
    loadError: "Error loading statistics",
    refreshed: "Statistics refreshed",
    refreshError: "Error refreshing",
    exported: "Data exported",
    noExportData: "No data to export",
    exportError: "Error exporting",
    loginRequired: "Login required",
    loginRequiredDesc: "Log in to see your usage statistics",
    loadingStats: "Loading your statistics...",
    monthlyUsage: "Monthly Usage",
    consumptionFor: "Your consumption for {{month}}",
    costUsed: "Cost used",
    nearLimit: "⚠️ You are approaching your monthly limit",
    requests: "Requests",
    tokens: "Tokens",
    plan: "Plan",
    dailyEvolution: "Daily evolution",
    byFunction: "By function",
    dailyEvolutionTitle: "Daily Evolution",
    usageByFunction: "Usage by Function",
    noUsageThisMonth: "No usage this month",
    noFunctionUsed: "No function used this month",
    requestsCount: "requests",
    cost: "Cost",
    tierLabels: {
      free: "Free",
      basic: "Basic",
      premium: "Premium",
      premium_free: "Premium Free",
      essential: "Essential",
      pro: "Pro",
    },
    funcLabels: {
      "chat-ai": "AI Chat",
      "code-suggest": "PMSI Coding",
      "generate-daily-quiz": "Daily Quiz",
      "generate-study-content": "MCQ Generation",
      "generate-flashcards-from-conversation": "Flashcards from conversation",
      "analyze-medication": "Drug analysis",
      "generate-study-from-conversation": "Study from conversation",
      "process-rss-feeds": "RSS Watch",
      "generate-clinical-case": "Clinical case",
    },
  },
  es: {
    title: "Mis Estadísticas",
    subtitle: "Tu uso de la IA este mes",
    loadingChart: "Cargando gráfico",
    export: "Exportar",
    refresh: "Actualizar",
    loadError: "Error al cargar las estadísticas",
    refreshed: "Estadísticas actualizadas",
    refreshError: "Error al actualizar",
    exported: "Datos exportados",
    noExportData: "No hay datos para exportar",
    exportError: "Error al exportar",
    loginRequired: "Inicio de sesión requerido",
    loginRequiredDesc: "Inicia sesión para ver tus estadísticas de uso",
    loadingStats: "Cargando tus estadísticas...",
    monthlyUsage: "Uso Mensual",
    consumptionFor: "Tu consumo de {{month}}",
    costUsed: "Coste usado",
    nearLimit: "⚠️ Te acercas a tu límite mensual",
    requests: "Solicitudes",
    tokens: "Tokens",
    plan: "Plan",
    dailyEvolution: "Evolución diaria",
    byFunction: "Por función",
    dailyEvolutionTitle: "Evolución Diaria",
    usageByFunction: "Uso por Función",
    noUsageThisMonth: "Sin uso este mes",
    noFunctionUsed: "Ninguna función usada este mes",
    requestsCount: "solicitudes",
    cost: "Coste",
    tierLabels: {
      free: "Gratuito",
      basic: "Básico",
      premium: "Premium",
      premium_free: "Premium Gratuito",
      essential: "Esencial",
      pro: "Pro",
    },
    funcLabels: {
      "chat-ai": "Chat IA",
      "code-suggest": "Codificación PMSI",
      "generate-daily-quiz": "Quiz del día",
      "generate-study-content": "Generación MCQ",
      "generate-flashcards-from-conversation": "Tarjetas desde conversación",
      "analyze-medication": "Análisis de medicamento",
      "generate-study-from-conversation": "Estudio desde conversación",
      "process-rss-feeds": "Vigilancia RSS",
      "generate-clinical-case": "Caso clínico",
    },
  },
};
